import { connect } from 'react-redux';
import InvoiceLineDetail from './InvoiceLinesDetail';
import { fetchAllocationRules, applyAllocationRuleToLine } from 'redux/rules/RulesActions';
import { fetchInvoiceById } from 'redux/invoices/InvoicesActions';
import { bindActionCreators } from "redux";


const mapStateToProps = ({ invoices, invoiceDetail, rules }) => ({
  fetchingJurisdictionalBreakdown: invoiceDetail.fetchingJurisdictionalBreakdown,
  invoiceDetail: invoiceDetail.invoiceDetail,
  isLineAllocated: invoiceDetail.isLineAllocated,
  rules: rules.rules,
  fetchingRules: rules.fetchingRules,
  pageState: rules.pageState,
  applyingAllocationRule: rules.applyingAllocationRule,
  invoiceData: invoices.invoice
});

const mapDispatchToProps = dispatch => ({
  rulesActions: bindActionCreators({ fetchAllocationRules, applyAllocationRuleToLine }, dispatch),
  invoicesActions: bindActionCreators({ fetchInvoiceById }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceLineDetail);



// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/c/invoiceLinesSlidingPanel/invoiceLinesDetail/InvoiceLinesDetailConnector.js